'use client';

import { ResetPage } from '@/components/ResetPage';
import { clientConfig } from '@/rollbar';
import { useEffect } from 'react';
import Rollbar from 'rollbar';

export default function GlobalError({
  error,
  reset,
}: {
  error: Error;
  reset: () => void;
}) {
  useEffect(() => {
    const rollbar = new Rollbar(clientConfig);
    rollbar.error(error);
  }, [error]);

  return (
    <html>
      <body>
        <ResetPage reset={reset} />;
      </body>
    </html>
  );
}
